import { c as _c } from "react/compiler-runtime";
import { ComponentType } from 'react';
import ErrorPageLayout from '../../components/ErrorPageLayout';
function WithErrorPageLayout<PropsType extends {}>(component: ComponentType<PropsType>) {
  const Page = component;
  const displayName = `WithErrorPageLayout`;
  const WrappedComponent: React.FC<PropsType> = function (props) {
    const $ = _c(2);
    let t0;
    if ($[0] !== props) {
      t0 = <ErrorPageLayout><Page {...props} /></ErrorPageLayout>;
      $[0] = props;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    return t0;
  };
  WrappedComponent.displayName = displayName;
  return WrappedComponent;
}
export default WithErrorPageLayout;